import { useContext } from 'react'

import { DashboardModule } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'
import { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useSystem from '@hooks/useSystem'

import type { SystemModel } from '@models/types'

type UseSystemPayload = ReturnType<typeof useSystem>

const handleUpdateSystem = (
  systemParams: Partial<SystemModel>,
  updateSystem: (payload: HandleCallbackActionParams) => Promise<object>,
  updateFn: UseSystemPayload['callbacks']['updateSystem'],
) => {
  const updateSystemPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: systemParams,
    toastText: 'System Updated',
  }

  updateSystem(updateSystemPayload)
}

const SystemSettings = (props: { systemPayload: UseSystemPayload }) => {
  const { systemPayload } = props

  const {
    callbacks: { updateSystem: updateFn },
    system,
    system: { options },
  } = systemPayload

  const { disable_sms_processing, internal_webhooks_enabled } = options || {}

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateSystem },
  } = pageContext

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column', padding: 'large' }} title="Settings">
      <ToggleListItem
        onClick={() => handleUpdateSystem(
          toggleNestedValue({ entityState: { ...system } }, 'options.disable_sms_processing'),
          updateSystem,
          updateFn,
        )}
        toggleValue={disable_sms_processing}
      >
        <ToggleListItem.Title>Disable SMS</ToggleListItem.Title>
        <ToggleListItem.Description>
          System will disable SMS processing
        </ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        boxProps={{ marginBottom: 0 }}
        onClick={() => handleUpdateSystem(
          toggleNestedValue({ entityState: { ...system } }, 'options.internal_webhooks_enabled'),
          updateSystem,
          updateFn,
        )}
        toggleValue={internal_webhooks_enabled}
      >
        <ToggleListItem.Title>Internal Webhooks Enabled</ToggleListItem.Title>
        <ToggleListItem.Description>
          System webhooks will be enabled
        </ToggleListItem.Description>
      </ToggleListItem>
    </DashboardModule>
  )
}

export default SystemSettings
